import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PieChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pie_chart"}/>
}
